import axiosInstance from "axiosConfig";
import { TOAST_TYPES_ENUM } from "enums";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { Toast } from "shared";
import { GetSmsCodeType } from "types/AuthTypes";
// import { useState } from "react";

// let lastSmsRequestTime = 0;
// const THROTTLE_TIME_MS = 30000; // 30 seconds in milliseconds
// const SILENT_THROTTLE_TIME_MS = 3000; // 3 seconds in milliseconds

export const useGetSmsCode = (
  options?: UseMutationOptions<any, Error, GetSmsCodeType>
) => {
  // const [isThrottled, setIsThrottled] = useState(false);
  const isThrottled = false;
  return useMutation({
    mutationKey: ["getSmsCode"],
    mutationFn: async (credentials: GetSmsCodeType) => {
      // const currentTime = Date.now();
      // const timeSinceLastRequest = currentTime - lastSmsRequestTime;
      // const throttleTime = credentials.isSilent ? SILENT_THROTTLE_TIME_MS : THROTTLE_TIME_MS;

      // if (timeSinceLastRequest < throttleTime) {
      //   setIsThrottled(true);
      //   const remainingSeconds = Math.ceil(
      //     (throttleTime - timeSinceLastRequest) / 1000
      //   );
      //   throw new Error(
      //     `Proszę odczekać ${remainingSeconds} sekund przed ponownym wysłaniem kodu`
      //   );
      // }

      // lastSmsRequestTime = currentTime;
      // setIsThrottled(false);

      return axiosInstance
        .get(`/auth/get-sms`, { params: credentials })
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      const isSilent = variables.isSilent;
      !isSilent &&
        Toast({
          message: "Trwa wysyłanie kodu SMS...",
          type: TOAST_TYPES_ENUM.LOADING,
          id: "getSmsCode",
        });
      if (options && options.onMutate) {
        // @ts-ignore
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      const isSilent = variables.isSilent;
      !isSilent &&
        Toast({
          message: "Wysłano kod SMS",
          type: TOAST_TYPES_ENUM.SUCCESS,
          id: "getSmsCode",
        });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error: any, variables, context) => {
      if (isThrottled) {
        Toast({
          message: error.message,
          type: TOAST_TYPES_ENUM.ERROR,
          id: "getSmsCode",
        });
      } else if (error?.status === 500) {
        Toast({
          message: "Błąd serwera",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "getSmsCode",
        });
      } else {

        //reset lastSmsRequestTime to allow sending code again
        // lastSmsRequestTime = 0;
        // setIsThrottled(false);
        Toast({
          message:
            "Nie udało się wysłać kodu, sprawdź poprawność numeru telefonu",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "getSmsCode",
        });
      }
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
